import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./authentication/page404/page404.component";
import { AuthGuard } from "./core/guard/auth.guard";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { AccessMenuGuard } from "./core/guard/accessMenu.guard";
const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "advance-table",
        loadChildren: () =>
          import("./advance-table/advance-table.module").then(
            (m) => m.AdvanceTableModule
          ),
      },
      {
        path: "calendar",
        loadChildren: () =>
          import("./calendar/calendar.module").then((m) => m.CalendarsModule),
          canActivate:[AccessMenuGuard]
      },
      {
        path: "presence",
        loadChildren: () =>
          import("./presence/presence.module").then((m) => m.PresenceModule),
          canActivate:[AccessMenuGuard]
      },
      {
        path: "extra-pages",
        loadChildren: () =>
          import("./extra-pages/extra-pages.module").then(
            (m) => m.ExtraPagesModule
          ),
          canActivate:[AccessMenuGuard]
      },
      {
        path: "task",
        loadChildren: () =>
          import("./task/task.module").then(
            (m) => m.TaskModule
          ),
          canActivate:[AccessMenuGuard]
      },
      {
        path: "document",
        loadChildren: () =>
          import("./documents/document.module").then(
            (m) => m.DocumentModule
          ),
          canActivate:[AccessMenuGuard]
      },
      {
        path: "examen",
        loadChildren: () =>
          import("./examen/examen.module").then(
            (m) => m.ExamenModule
          ),
          canActivate:[AccessMenuGuard]
      },
      {
        path: "evaluation",
        loadChildren: () =>
          import("./evaluation/evaluation.module").then(
            (m) => m.EvaluationModule
          ),
          canActivate:[AccessMenuGuard]
      },
      {
        path: "multilevel",
        loadChildren: () =>
          import("./multilevel/multilevel.module").then(
            (m) => m.MultilevelModule
          ),
      },
    ],
  },
  {
    path: "authentication",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
